import {da, de, enUS, fr, nl} from "date-fns/locale";
import * as React from "react";
import {forwardRef, useState} from "react";
import DatePicker, {registerLocale} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {useTranslation} from "react-i18next";
import {useMediaQuery} from "react-responsive";
import styles from "./ShippingDatePicker.module.scss";
import buttonStyles from "../../../lib/form/Button/Button.module.scss";

registerLocale("de", de);
registerLocale("da", da);
registerLocale("en", enUS);
registerLocale("fr", fr);
registerLocale("nl", nl);

interface IShippingDateProps {
  deliveryDate: string | null;
  onDeliveryDateChange: (date: string | null) => void;
}

/**
 * row to set desired delivery date
 * @param props
 * @constructor
 */
const ShippingDatePicker: React.FC<IShippingDateProps> = (props) => {
  const {t} = useTranslation("checkout");
  const {deliveryDate, onDeliveryDateChange} = props;
  const [selectedDate, setSelectedDate] = useState<Date | null>(
    !!deliveryDate ? new Date(Date.parse(deliveryDate)) : null,
  );
  const isMobile = useMediaQuery({
    query: "(max-width:768px)",
  });
  const reference = React.createRef<HTMLDivElement>();
  const locale: string = (document.querySelector("html") as HTMLHtmlElement).getAttribute("lang") ?? "de";

  const DatePickerInput = forwardRef<HTMLDivElement>(
    ({value, onClick}: React.InputHTMLAttributes<HTMLDivElement>, ref) => (
      <div
        ref={ref}
        className={`${buttonStyles.buttonPrimary} ${buttonStyles.datepicker}`}
        onClick={(evt) => {
          evt.preventDefault();
          if (onClick) onClick(evt);
        }}
      >
        {value ? value.toString() : t("Wunschdatum")}
      </div>
    ),
  );
  DatePickerInput.displayName = "DatePickerInput";

  return (
    <div className={`${styles.wrapper} ArrowBorder`}>
      <div>{t("Bitte versenden Sie die Ware erst am")}:</div>
      <div>
        <DatePicker
          selected={selectedDate}
          onChange={(date: Date) => {
            setSelectedDate(date);
            onDeliveryDateChange(
              !date ? null : `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`,
            );
          }}
          withPortal={isMobile}
          customInput={<DatePickerInput ref={reference} />}
          locale={locale}
          dateFormat={"P"}
          minDate={new Date()}
          isClearable
        />
      </div>
    </div>
  );
};

export default ShippingDatePicker;

export const pad = (num: number): string => {
  return `00${num}`.slice(-2);
};
